import { CheckCircle2 } from "lucide-react";
import { COMPANY, FRAMING_IMAGE } from "@/data/site";

const POINTS = [
  "Quality workmanship on projects of every size",
  "Residential, commercial & remodeling expertise",
  "Reliable scheduling and professional results",
  "A trusted network for any service we don't perform",
];

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="bg-navy-900/40 border-y border-navy-700 py-24 sm:py-32"
    >
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <div>
            <p className="font-display text-sm font-bold uppercase tracking-[0.3em] text-brand-light mb-4">
              Why Choose LVM
            </p>
            <h2 className="font-display font-black uppercase text-white text-4xl sm:text-5xl tracking-tight">
              Workmanship
              <br />
              You Can Trust.
            </h2>
            <p className="mt-8 text-lg text-zinc-300 leading-relaxed">
              {COMPANY.name} is a full-service construction company specializing
              in drywall, framing, and acoustical ceiling systems. Led by owner{" "}
              <span className="text-white font-semibold">{COMPANY.owner}</span>,
              we're committed to making the process simple and delivering
              customer satisfaction on every project.
            </p>

            <ul className="mt-8 space-y-4">
              {POINTS.map((p) => (
                <li key={p} className="flex items-start gap-3">
                  <CheckCircle2 className="w-6 h-6 text-brand-light shrink-0 mt-0.5" />
                  <span className="text-zinc-200 text-base sm:text-lg">{p}</span>
                </li>
              ))}
            </ul>

            <div className="mt-10 border-l-4 border-brand pl-6">
              <p className="font-display text-xl sm:text-2xl font-bold uppercase tracking-tight text-white leading-snug">
                "{COMPANY.slogan}"
              </p>
            </div>
          </div>

          <div className="relative">
            <div className="absolute -top-4 -left-4 w-full h-full border-2 border-navy-700 hidden sm:block" />
            <img
              src={FRAMING_IMAGE}
              alt="Interior metal framing work"
              data-testid="about-image"
              className="relative w-full h-[420px] sm:h-[520px] object-cover"
            />
            <div className="absolute bottom-0 right-0 bg-brand px-8 py-6">
              <p className="font-display font-black text-3xl text-navy-950 leading-none">
                100%
              </p>
              <p className="font-display text-xs font-bold uppercase tracking-widest text-navy-900 mt-1">
                Committed to Quality
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
